import { render } from "./createTemplateProposalComponent.vue?vue&type=template&id=09a3c59a&scoped=true"
import script from "./createTemplateProposalComponent.vue?vue&type=script&lang=js"
export * from "./createTemplateProposalComponent.vue?vue&type=script&lang=js"

import "./createTemplateProposalComponent.vue?vue&type=style&index=0&id=09a3c59a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a3c59a"]])

export default __exports__